import {api} from 'helpers/api';
import {success, error} from 'helpers/response';

export const getStopPoints = (meta = {}) => async (dispatch, state) => {
    try {
        const response = await api.geo.getStopPoints(meta);

        return success(response);
    }
    catch (e) {
        return error(e);
    }
};

export const getClosestStopPoint = (latitude, longitude) => async (dispatch, state) => {
    try {
        const response = await api.geo.getClosestStopPoint(latitude, longitude);

        return success(response);
    }
    catch (e) {
        return error(e);
    }
};

export const getStopPointsWithBounds = (boundingBox, zoom, source = 'inventarisation_active') => async (dispatch, state) => {
    try {
        const response = await api.geo.getStopPoints({
            filters: {
                withBoundingBox: boundingBox,
                withZoom: zoom,
                withSource: source,
            },
        });

        return success(response);
    }
    catch (e) {
        return error(e);
    }
};

export const getStopPointRoutes = (uuid) => async (dispatch, state) => {
    try {
        const response = await api.geo.getStopPointRoutes(uuid);

        return success(response);
    }
    catch (e) {
        return error(e);
    }
};

export const getStopPointRouteRuns = (uuid, routeUuid, time = null, onlyFirst = false, page = 1) => async (dispatch, state) => {
    try {
        const response = await api.geo.getStopPointRouteRuns(uuid, routeUuid, time, onlyFirst, page);

        return success(response);
    }
    catch (e) {
        return error(e);
    }
};


// WEBPACK FOOTER //
// ./src/store/reducers/routes/routes.js